var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<input type=\"text\" name=\"query\" placeholder=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"search_hint_string") || (depth0 != null ? lookupProperty(depth0,"search_hint_string") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"search_hint_string","hash":{},"data":data,"loc":{"start":{"line":1,"column":45},"end":{"line":1,"column":67}}}) : helper)))
    + "\" id=\"tool-search-query\" autocomplete=\"off\" class=\"search-query parent-width\" />\n<a id=\"search-clear-btn\" title=\"clear search (esc)\"> </a>\n<img src=\""
    + alias4(((helper = (helper = lookupProperty(helpers,"spinner_url") || (depth0 != null ? lookupProperty(depth0,"spinner_url") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"spinner_url","hash":{},"data":data,"loc":{"start":{"line":3,"column":10},"end":{"line":3,"column":25}}}) : helper)))
    + "\" id=\"search-spinner\" class=\"search-spinner\"/>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./galaxy/scripts/templates/tool_search.handlebars
// module id = 69
// module chunks = 0 3